var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g2, _path14, _path15, _path16, _path17, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultNotFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 124,
    viewBox: "0 0 147 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.192 62.9103C125.192 73.7882 121.966 84.4219 115.923 93.4666C109.879 102.511 101.289 109.561 91.2395 113.724C81.1896 117.886 70.1309 118.976 59.4619 116.853C48.793 114.731 38.9929 109.493 31.301 101.801C23.6092 94.1092 18.3709 84.3092 16.2487 73.6402C14.1265 62.9713 15.2157 51.9126 19.3785 41.8627C23.5414 31.8127 30.5908 23.2229 39.6356 17.1794C48.6803 11.136 59.3139 7.91028 70.1919 7.91028C84.7788 7.91028 98.7683 13.7049 109.083 24.0194C119.397 34.3339 125.192 48.3234 125.192 62.9103Z",
    fill: "#F2EEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1919 33.2755C43.1919 30.4118 45.4867 28.0903 48.3174 28.0903L78.2287 28.0903C79.4494 28.0903 80.4791 29.0099 80.6306 30.2354C80.6973 30.7757 80.9402 31.2781 81.3208 31.6632L87.7266 38.1435L95.7476 46.2579C95.7964 46.3073 95.8626 46.335 95.9316 46.335C96.0754 46.335 96.1919 46.4529 96.1919 46.5983V92.9051C96.1919 95.7688 93.8971 98.0903 91.0664 98.0903H48.3174C45.4867 98.0903 43.1919 95.7688 43.1919 92.9051V33.2755Z",
    fill: "#6B409C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3819_5327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3385 57.9051C46.3385 56.4732 47.4859 55.3125 48.9013 55.3125H90.4826C91.8979 55.3125 93.0453 56.4732 93.0453 57.9051V70.6751C93.0453 72.107 91.8979 73.2677 90.4826 73.2677H48.9013C47.4859 73.2677 46.3385 72.107 46.3385 70.6751V57.9051Z",
    fill: "#BAAADB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1409 58.62C49.1409 57.8372 49.7682 57.2025 50.5421 57.2025H60.8176C61.5914 57.2025 62.2188 57.8372 62.2188 58.62C62.2188 59.4029 61.5914 60.0375 60.8176 60.0375H50.5421C49.7682 60.0375 49.1409 59.4029 49.1409 58.62Z",
    fill: "#F2EEFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1409 67.1251C49.1409 66.8641 49.35 66.6526 49.6079 66.6526H82.3027C82.5607 66.6526 82.7698 66.8641 82.7698 67.1251C82.7698 67.3861 82.5607 67.5976 82.3027 67.5976H49.6079C49.35 67.5976 49.1409 67.3861 49.1409 67.1251Z",
    fill: "#F2EEFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1409 69.0152C49.1409 68.7543 49.35 68.5427 49.6079 68.5427H52.4103C52.6683 68.5427 52.8774 68.7543 52.8774 69.0152C52.8774 69.2762 52.6683 69.4877 52.4103 69.4877H49.6079C49.35 69.4877 49.1409 69.2762 49.1409 69.0152Z",
    fill: "#F2EEFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7457 69.0152C54.7457 68.7543 54.9548 68.5427 55.2128 68.5427H58.0152C58.2732 68.5427 58.4823 68.7543 58.4823 69.0152C58.4823 69.2762 58.2732 69.4877 58.0152 69.4877H55.2128C54.9548 69.4877 54.7457 69.2762 54.7457 69.0152Z",
    fill: "#F2EEFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3505 69.0152C60.3505 68.7543 60.5596 68.5427 60.8175 68.5427H63.6199C63.8779 68.5427 64.087 68.7543 64.087 69.0152C64.087 69.2762 63.8779 69.4877 63.6199 69.4877H60.8175C60.5596 69.4877 60.3505 69.2762 60.3505 69.0152Z",
    fill: "#F2EEFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9553 69.0152C65.9553 68.7543 66.1644 68.5427 66.4224 68.5427H69.2248C69.4828 68.5427 69.6919 68.7543 69.6919 69.0152C69.6919 69.2762 69.4828 69.4877 69.2248 69.4877H66.4224C66.1644 69.4877 65.9553 69.2762 65.9553 69.0152Z",
    fill: "#F2EEFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5602 69.0152C71.5602 68.7543 71.7693 68.5427 72.0272 68.5427H74.8297C75.0876 68.5427 75.2967 68.7543 75.2967 69.0152C75.2967 69.2762 75.0876 69.4877 74.8297 69.4877H72.0272C71.7693 69.4877 71.5602 69.2762 71.5602 69.0152Z",
    fill: "#F2EEFB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5063 57.675C86.5063 57.4141 86.7155 57.2025 86.9734 57.2025H89.7758C90.0338 57.2025 90.2429 57.4141 90.2429 57.675C90.2429 57.936 90.0338 58.1475 89.7758 58.1475H86.9734C86.7155 58.1475 86.5063 57.936 86.5063 57.675Z",
    fill: "#F2EEFB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5721 69.9602C85.5721 69.1774 86.1995 68.5427 86.9733 68.5427H88.8416C89.6155 68.5427 90.2428 69.1774 90.2428 69.9602C90.2428 70.7431 89.6155 71.3778 88.8416 71.3778H86.9733C86.1995 71.3778 85.5721 70.7431 85.5721 69.9602Z",
    fill: "#F2EEFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1409 62.4001C49.1409 61.6172 49.7682 60.9825 50.5421 60.9825H72.9614C73.7352 60.9825 74.3626 61.6172 74.3626 62.4001C74.3626 63.1829 73.7352 63.8176 72.9614 63.8176H50.5421C49.7682 63.8176 49.1409 63.1829 49.1409 62.4001Z",
    fill: "#F2EEFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9015 57.675C80.9015 57.4141 81.1106 57.2025 81.3686 57.2025H84.171C84.4289 57.2025 84.638 57.4141 84.638 57.675C84.638 57.936 84.4289 58.1475 84.171 58.1475H81.3686C81.1106 58.1475 80.9015 57.936 80.9015 57.675Z",
    fill: "#F2EEFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.3447 80.9627V28.0903L78.8933 28.0903L96.192 45.9627V80.9627H48.3447Z",
    fill: "url(#paint0_linear_3819_5327)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1919 46.7074H82.4512C80.2919 46.7074 78.5253 44.8457 78.5253 42.5702V28.0903C79.0356 28.0903 79.546 28.2972 79.8992 28.711L95.6029 45.2595C95.9956 45.6317 96.1919 46.1695 96.1919 46.7074Z",
    fill: "#BAAADB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f_3819_5327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.89 96.0602L119.592 92.3581L128.386 101.152L124.684 104.854L115.89 96.0602Z",
    fill: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2067 64.6486C85.1507 67.7066 83.0699 71.6021 82.2273 75.8427C81.3848 80.0833 81.8183 84.4786 83.4731 88.4728C85.1278 92.467 87.9296 95.8808 91.524 98.2826C95.1185 100.684 99.3443 101.966 103.667 101.966C107.99 101.966 112.216 100.684 115.81 98.2826C119.405 95.8808 122.206 92.467 123.861 88.4728C125.516 84.4786 125.949 80.0833 125.107 75.8427C124.264 71.6021 122.184 67.7066 119.128 64.6486C115.026 60.5503 109.465 58.2483 103.667 58.2483C97.8692 58.2483 92.3085 60.5503 88.2067 64.6486ZM116.184 92.6302C113.709 95.104 110.556 96.7883 107.124 97.4701C103.691 98.152 100.134 97.8008 96.9016 96.4609C93.6691 95.121 90.9062 92.8526 88.9624 89.9425C87.0187 87.0324 85.9812 83.6112 85.9812 80.1115C85.9812 76.6117 87.0187 73.1906 88.9624 70.2805C90.9062 67.3704 93.6691 65.102 96.9016 63.7621C100.134 62.4222 103.691 62.071 107.124 62.7528C110.556 63.4347 113.709 65.1189 116.184 67.5927C117.828 69.2363 119.133 71.1879 120.023 73.3359C120.913 75.4839 121.371 77.7863 121.371 80.1115C121.371 82.4367 120.913 84.7391 120.023 86.8871C119.133 89.0351 117.828 90.9867 116.184 92.6302Z",
    fill: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.167 101.917L136.256 119.005C137.098 119.814 138.224 120.26 139.392 120.248C140.559 120.236 141.676 119.767 142.501 118.942C143.327 118.116 143.796 116.999 143.808 115.832C143.82 114.664 143.374 113.538 142.565 112.696L125.476 95.6074L119.167 101.917Z",
    fill: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.965 94.7425L118.316 102.398C118.208 102.503 118.123 102.629 118.065 102.767C118.006 102.906 117.976 103.054 117.975 103.204C117.974 103.355 118.003 103.504 118.059 103.643C118.116 103.782 118.2 103.908 118.306 104.015C118.412 104.122 118.538 104.206 118.677 104.264C118.815 104.321 118.964 104.351 119.114 104.351C119.264 104.351 119.413 104.321 119.552 104.263C119.69 104.205 119.816 104.121 119.922 104.014L127.572 96.3586C127.679 96.254 127.764 96.129 127.822 95.991C127.881 95.8529 127.911 95.7046 127.911 95.5548C127.911 95.405 127.881 95.2567 127.822 95.1187C127.764 94.9806 127.679 94.8556 127.572 94.751C127.36 94.5374 127.071 94.4166 126.77 94.4151C126.469 94.4135 126.18 94.5312 125.965 94.7425Z",
    fill: "#3D0E6B"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.654 94.4336L116.506 90.5815L125.656 99.7317L121.804 103.584L112.654 94.4336Z",
    fill: "#6B409C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8496 61.7499C80.6699 64.9317 78.5048 68.985 77.6281 73.3973C76.7514 77.8097 77.2025 82.383 78.9243 86.539C80.6461 90.695 83.5613 94.247 87.3013 96.7461C91.0414 99.2452 95.4383 100.579 99.9363 100.579C104.434 100.579 108.831 99.2452 112.571 96.7461C116.311 94.247 119.226 90.695 120.948 86.539C122.67 82.383 123.121 77.8097 122.244 73.3973C121.368 68.985 119.203 64.9317 116.023 61.7499C111.755 57.4856 105.969 55.0903 99.9363 55.0903C93.9035 55.0903 88.1176 57.4856 83.8496 61.7499ZM112.96 90.8648C110.385 93.4388 107.104 95.1913 103.533 95.9007C99.9616 96.6102 96.2603 96.2447 92.8968 94.8506C89.5332 93.4565 86.6585 91.0962 84.636 88.0682C82.6135 85.0403 81.534 81.4805 81.534 77.839C81.534 74.1975 82.6135 70.6378 84.636 67.6098C86.6585 64.5819 89.5332 62.2216 92.8968 60.8275C96.2603 59.4333 99.9616 59.0679 103.533 59.7773C107.104 60.4868 110.385 62.2393 112.96 64.8133C114.671 66.5234 116.028 68.554 116.955 70.789C117.881 73.024 118.357 75.4197 118.357 77.839C118.357 80.2584 117.881 82.654 116.955 84.8891C116.028 87.1241 114.671 89.1547 112.96 90.8648Z",
    fill: "#5C2E8C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.064 100.527L133.845 118.308C134.721 119.149 135.892 119.614 137.107 119.601C138.322 119.589 139.484 119.101 140.343 118.242C141.202 117.383 141.69 116.221 141.703 115.006C141.715 113.791 141.251 112.62 140.409 111.743L122.629 93.9625L116.064 100.527Z",
    fill: "#5C2E8C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.138 93.0627L115.178 101.028C115.067 101.138 114.978 101.268 114.917 101.412C114.856 101.556 114.824 101.711 114.823 101.867C114.822 102.024 114.852 102.179 114.912 102.323C114.971 102.468 115.058 102.6 115.168 102.711C115.278 102.822 115.409 102.91 115.554 102.97C115.698 103.03 115.853 103.06 116.009 103.06C116.165 103.06 116.32 103.029 116.464 102.969C116.609 102.909 116.739 102.821 116.85 102.71L124.809 94.7442C124.921 94.6354 125.009 94.5053 125.07 94.3617C125.13 94.2181 125.162 94.0638 125.162 93.9079C125.162 93.752 125.13 93.5977 125.07 93.454C125.009 93.3104 124.921 93.1803 124.809 93.0715C124.588 92.8493 124.289 92.7236 123.975 92.7219C123.662 92.7203 123.361 92.8428 123.138 93.0627Z",
    fill: "#5C2E8C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.9362,
    cy: 77.8347,
    r: 18.609,
    fill: "#F2EEFB",
    fillOpacity: 0.21
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.19189,
    y: 116.884,
    width: 25.1642,
    height: 7.10734,
    rx: 3.55367,
    transform: "rotate(-45 5.19189 116.884)",
    fill: "url(#paint1_linear_3819_5327)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.191895,
    y: 78.2043,
    width: 10.0607,
    height: 7.10734,
    rx: 3.55367,
    transform: "rotate(-45 0.191895 78.2043)",
    fill: "url(#paint2_linear_3819_5327)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.19189,
    y: 95.8842,
    width: 53.7031,
    height: 7.10734,
    rx: 3.55367,
    transform: "rotate(-45 7.19189 95.8842)",
    fill: "url(#paint3_linear_3819_5327)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 101.866,
    y: 53.21,
    width: 35.5246,
    height: 7.10734,
    rx: 3.55367,
    transform: "rotate(-45 101.866 53.21)",
    fill: "url(#paint4_linear_3819_5327)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 104.192,
    y: 7.20435,
    width: 10.0607,
    height: 7.10734,
    rx: 3.55367,
    transform: "rotate(-45 104.192 7.20435)",
    fill: "url(#paint5_linear_3819_5327)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 111.192,
    y: 24.8842,
    width: 29.8973,
    height: 7.10734,
    rx: 3.55367,
    transform: "rotate(-45 111.192 24.8842)",
    fill: "url(#paint6_linear_3819_5327)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3819_5327",
    x: 42.3385,
    y: 53.3125,
    width: 54.7068,
    height: 25.9552,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0863351 0 0 0 0 0 0 0 0 0 0.170833 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3819_5327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3819_5327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3819_5327",
    x: 78.8081,
    y: 55.2483,
    width: 68.0001,
    height: 68.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_3819_5327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3819_5327",
    x1: 84.8367,
    y1: 45.5903,
    x2: 54.4321,
    y2: 71.1689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191395,
    stopColor: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481734,
    stopColor: "#3D0E6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3819_5327",
    x1: -0.258242,
    y1: 120.731,
    x2: 23.7847,
    y2: 120.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.127403,
    stopColor: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D0E6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3819_5327",
    x1: -1.98709,
    y1: 82.0513,
    x2: 7.62538,
    y2: 82.0513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.127403,
    stopColor: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D0E6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3819_5327",
    x1: -4.43929,
    y1: 99.7311,
    x2: 46.871,
    y2: 99.7311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBCC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#FFBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3819_5327",
    x1: 94.1722,
    y1: 57.0569,
    x2: 128.114,
    y2: 57.0569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#3D0E6B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D0E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3819_5327",
    x1: 102.013,
    y1: 11.0513,
    x2: 111.625,
    y2: 11.0513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#3D0E6B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D0E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3819_5327",
    x1: 104.717,
    y1: 28.7311,
    x2: 133.282,
    y2: 28.7311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FFBCC7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBCC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultNotFound);
export default __webpack_public_path__ + "static/media/result_not_found.2cc4c6ead44242986e49924d08214461.svg";
export { ForwardRef as ReactComponent };